module.exports = __webpack_public_path__ + "static/img/77010A_2_R_20180427_n_LC.03b9df5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/77010A_2_R_20180427_n_LC.png
// module id = kjfo
// module chunks = 0